"use client";

import { FileText, Music, Play } from "lucide-react";

import { t } from "@/lib/localization";
import { cn } from "@/lib/utils";
import type { LomdaV3AssetType } from "@/lib/utils/lomdaV3/types";
import type { LomdaLibraryItem } from "../../../lib/mediaAssets";

const TYPE_LABEL: Record<LomdaV3AssetType, string> = {
    image: "lomda-v3-editor.media.image",
    video: "lomda-v3-editor.media.video",
    audio: "lomda-v3-editor.block-type.audio",
    file: "lomda-v3-editor.media-variant.document",
};

export default function AssetThumb({
    item,
    name,
}: {
    item: LomdaLibraryItem;
    name: string;
}) {
    if (item.type === "image")
        return (
            // eslint-disable-next-line @next/next/no-img-element
            <img
                src={item.url}
                alt={name}
                loading="lazy"
                decoding="async"
                className={cn(
                    "size-full",
                    item.isIcon ? "object-contain p-3" : "object-cover"
                )}
            />
        );
    if (item.type === "video") {
        const playBadge = (
            <Play className="absolute size-6 fill-white text-primary-foreground drop-shadow" />
        );
        if (item.thumbnailUrl)
            return (
                <>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        src={item.thumbnailUrl}
                        alt={name}
                        loading="lazy"
                        decoding="async"
                        className="size-full object-cover"
                    />
                    {playBadge}
                </>
            );
        return <Play className="size-6 text-muted-foreground" />;
    }
    if (item.type === "audio")
        return <Music className="size-6 text-muted-foreground" />;
    return <FileText className="size-6 text-muted-foreground" />;
}

export const assetName = (item: LomdaLibraryItem) =>
    item.name || t(TYPE_LABEL[item.type]);
